import React from 'react';
import useTranslation from 'Hooks/useTranslation';
import useFetch from './Hooks/useFetch';
import style from './style';

const { ContainerBasicInfo, ContainerDescription, ContainerIncludes, descriptionText, trainingText, trainingList } =
  style;

export default function Information({ course }) {
  const { contentCountValue } = useFetch(course[course.length - 1]);

  const { t2 } = useTranslation('CourseDetails');
  const courseDetailList = [
    {
      number: contentCountValue?.videoCount,
      text: t2('TrainingVideo'),
      textSingle: t2('TrainingVideoSingle'),
    },
    {
      number: contentCountValue?.audioCount,
      text: t2('TrainingAudio'),
      textSingle: t2('TrainingAudioSingle'),
    },
    {
      number: contentCountValue?.documentCount,
      text: t2('TrainingDocument'),
      textSingle: t2('TrainingDocumentSingle'),
    },
    {
      number: contentCountValue?.evaluationCount,
      text: t2('TrainingEvaluation'),
      textSingle: t2('TrainingEvaluationSingle'),
    },
  ];

  return (
    <ContainerBasicInfo>
      <ContainerDescription>
        <div>{t2('Description')}</div>
        <div style={descriptionText}>{course[1]}</div>
      </ContainerDescription>
      <ContainerIncludes>
        <div>{t2('TrainingSentence')}</div>
        <ul style={trainingList}>
          {courseDetailList.map((features, index) =>
            features.number === 1 ? (
              <li key={index} style={trainingText}>
                {features.number} {features.textSingle}
              </li>
            ) : (
              <li key={index} style={trainingText}>
                {features.number} {features.text}
              </li>
            )
          )}
        </ul>
      </ContainerIncludes>
    </ContainerBasicInfo>
  );
}
